import React from "react";
import { motion } from "framer-motion";
import { ShieldAlert } from "lucide-react";
import { DISCLOSURE_PARAGRAPHS } from "@/data/site";

// Full mandatory legal disclosure block. Prominent, not fine print.
export default function LegalDisclosure({ className = "" }) {
  return (
    <motion.section
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.5 }}
      className={className}
      data-testid="legal-disclosure-block"
    >
      <div className="rounded-lg border-2 border-[#D4AF37]/60 bg-[#0B1B3D] p-8 text-white sm:p-10 lg:p-12">
        <div className="flex items-center gap-3">
          <ShieldAlert className="h-7 w-7 flex-shrink-0 text-[#D4AF37]" />
          <h2 className="font-serif text-2xl font-semibold sm:text-3xl">Important Disclosure</h2>
        </div>
        <div className="mt-6 space-y-4 text-[15px] leading-relaxed text-slate-200">
          {DISCLOSURE_PARAGRAPHS.map((p) => (
            <p key={p}>{p}</p>
          ))}
        </div>
      </div>
    </motion.section>
  );
}
